import { render, staticRenderFns } from "./HintSection.vue?vue&type=template&id=72b7160f&"
import script from "./HintSection.vue?vue&type=script&lang=js&"
export * from "./HintSection.vue?vue&type=script&lang=js&"
import style0 from "./HintSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports